import React, { useEffect, useState } from "react";
import { Button, Tooltip } from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import CallEndIcon from "@mui/icons-material/CallEnd";
import {
  endVoiceCall,
  startVoiceCall,
} from "../../realtimeCommunication/socketConnection";

const VoiceCallButton = ({ receiverUserId }) => {
  const [isCalling, setIsCalling] = useState(false);

  useEffect(() => {
    const handleCallEnded = () => setIsCalling(false);
    window.addEventListener("voice-call-ended", handleCallEnded);

    return () => {
      window.removeEventListener("voice-call-ended", handleCallEnded);
    };
  }, []);

  const handleStartCall = async () => {
    try {
      await startVoiceCall(receiverUserId);
      setIsCalling(true);
    } catch (error) {
      setIsCalling(false);
      window.alert("Для голосовых звонков нужен доступ к микрофону.");
    }
  };

  const handleEndCall = () => {
    endVoiceCall();
    setIsCalling(false);
  };

  return (
    <Tooltip title={isCalling ? "Завершить звонок" : "Начать голосовой звонок"}>
      <Button
        variant="contained"
        startIcon={isCalling ? <CallEndIcon /> : <PhoneIcon />}
        onClick={isCalling ? handleEndCall : handleStartCall}
        sx={{
          bgcolor: isCalling ? "#da373c" : "#f97316",
          color: "#ffffff",
          minWidth: "132px",
          height: "36px",
          borderRadius: "4px",
          fontWeight: 700,
          textTransform: "none",
          boxShadow: "none",
          "&:hover": {
            bgcolor: isCalling ? "#a12828" : "#ea580c",
            boxShadow: "none",
          },
        }}
      >
        {isCalling ? "Завершить" : "Позвонить"}
      </Button>
    </Tooltip>
  );
};

export default VoiceCallButton;
